import clsx from "clsx";
import BlocksNavigation from "../Navigation/BlocksNavigation";
import { useTranslation } from "react-i18next";
import {
  MdAdd,
  MdOutlineRepeat,
  MdOutlineSwapVert,
  MdQueryStats,
} from "react-icons/md";
import { useLocation } from "react-router-dom";
import useMainFilter from "../../hooks/useMainFilter";
import { ICON_SIZES } from "../../helpers/constants";
import React, { ReactElement, useMemo } from "react";

interface IMobileNavigation {
  children?: ReactElement;
}

const MobileNavigation: React.FC<IMobileNavigation> = ({ children }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { mainFilter } = useMainFilter();

  const isActiveLink = (link: string) => pathname?.startsWith(link);

  const links = useMemo(() => {
    return [
      {
        link: `/reports/${mainFilter?.account || ""}`,
        text: t("menu.reports"),
        icon: <MdQueryStats size={ICON_SIZES.MD_LG} />,
        active: isActiveLink("/reports"),
      },
      {
        link: `/transactions/${mainFilter?.account || ""}`,
        text: t("menu.transactions"),
        icon: <MdOutlineSwapVert size={ICON_SIZES.MD_LG} />,
        active: isActiveLink(`/transactions/${mainFilter?.account || ""}`),
      },
      {
        link: `/transaction/${mainFilter?.account || ""}`,
        text: t("Nueva"),
        icon: <MdAdd size={ICON_SIZES.MD_LG} />,
        active: isActiveLink(`/transaction/${mainFilter?.account || ""}`),
      },
      {
        link: `/recurring/${mainFilter?.account || ""}`,
        text: "Recurrentes",
        active: isActiveLink(`/recurring/${mainFilter?.account || ""}`),
        icon: <MdOutlineRepeat size={ICON_SIZES.MD_LG} />,
      },
    ];
  }, [isActiveLink, mainFilter?.account, children]);

  return (
    <div
      className={clsx([
        "fixed",
        "bottom-0",
        "right-0",
        "left-0",
        "md:hidden",
        "md:border-0",
        {
          "bg-blue-900 dark:bg-gray-900": !children,
        },
        "shadow-[0_5px_7px_7px_rgba(0,_0,_0,_0.1)]",
        "dark:shadow-[0_5px_7px_7px_rgba(0,_0,_0,_0.5)]",
      ])}
    >
      {children && <div className={clsx([""])}>{children}</div>}
      <div
        className={clsx([
          "justify-center",
          "item-center",
          "flex",
          "w-full",
          "gap-2",
          "flex-col",
          "text-white",
          "dark:text-white",
          "bg-blue-900 dark:bg-gray-900",
          "pb-[calc(10px+env(safe-area-inset-bottom))]",
        ])}
      >
        <BlocksNavigation links={links} />
        <div
          className={clsx([
            "flex",
            "w-full",
            "h-[5px]",
            "bg-gray-800/0",
            "rounded-full",
            "overflow-hidden",
            "hidden",
          ])}
        />
      </div>
    </div>
  );
};

export default MobileNavigation;
